export default __webpack_public_path__ + "assets/community-two-two-small.b9211a6237841658eca165e5847285ed.png";